module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAACXBIWXMAABYlAAAWJQFJUiTwAAABFklEQVRoge3Wbw3CMBCH4R8OJgEJcwA4mIRJQAIOkIAEQMEkAAqGA3AAWXIfRtOxG+sICe+TNOHLrr27/kEAAAAAAAAA/kRuo9dsRD0KSYuOia6SLpIO9ju1k6S5pJWkc+rgTWK1pIdz7CWVCefftOa9eTvptR6QWDhqW1w2Yv4yErf4RnJNJSsbnmR3tsWGyG2eME4SscrdrCOxheZWkJMjUU9Hy0hyTewxu+FlsbHg3g4sLZF33d92nKXcznDsm2RnL+zCp5Wb9yTajl+9uciSJheeu3rkJaFWouGu8F5USW/NLOhgshvLYm8GPDnbT4rreegz2zJ3e1inUFhnFpHYxwn/MLwkuZxyAgAAAAAAAAA/QdITn12mKkG75dkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/ic_date@2x.png
// module id = 149
// module chunks = 0